"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.countryToCurrency = exports.getCurrencyFromLocale = exports.DEFAULT_LOCALE = exports.LOCALE_KEY = exports.isSupportedLocaleType = exports.supportedLocales = exports.getSupportedLocaleFromAnyLocale = exports.localeToLanguage = exports.SupportedLanguages = exports.FrontendLocales = exports.shortLocaleToBestOption = exports.SupportedLocales = exports.CurrencyCode = exports.LanguageCode = void 0;
exports.extractLocalesFromAcceptLanguageHeader = extractLocalesFromAcceptLanguageHeader;
exports.extractLocaleInformation = extractLocaleInformation;
var Countries_1 = require("./Countries");
/**
 * We use The BCP47 standard
 *
 * - The BCP47 standard provides a way to represent language tags using a combination of two-letter language codes,
 *   optional four-letter script codes, and optional two-letter region codes. For example, "en-US" represents American English, while "fr-CA" represents Canadian French.
 *
 * - BCP47 also supports the use of private-use subtags, which allow users to create their own language tags for specialized or experimental purposes.
 * - Language tags can be used to identify the language used in a text string or web page, as well as to control the display of certain language-specific features,
 *   such as date and time formats, currency symbols, and sorting order.
 * - The BCP47 standard also defines a number of extensions that allow for additional language and region information to be included in a language tag.
 *   These include extensions for specifying language variations, transliterations, and orthographies, as well as extensions for identifying language-specific cultural conventions,
 * such as address formats and calendar systems.
 *
 * @example Japanese with the "Hiragana" script: "ja-Hira-JP"
 * This language tag represents Japanese text written using the Hiragana script, as it is used in Japan.
 *
 * @example Simplified Chinese with the "Pinyin" romanization system: "zh-Latn-pinyin-CN"
 * This language tag represents Simplified Chinese text written using the Pinyin romanization system, as it is used in China.
 *
 * @example English with a variant for Australian English: "en-AU-oxendict"
 * This language tag represents English text as used in Australia, with the "oxendict" variant indicating that the Oxford English Dictionary spelling conventions are being used.
 *
 * Our standard should follow the use of UPPER_CASE regions (CA, US, GB, etc.)
 *
 * NOTE, for consistency we use Intl:
 *   - To extract locale information you can simply do
 *     const en = new Intl.Local("en-US")
 *     en.region -> US
 *     en.language -> en
 *     etc.
 */
/**
 * Source: https://wiki.openstreetmap.org/wiki/Nominatim/Country_Codes
 */
var LanguageCode;
(function (LanguageCode) {
    LanguageCode["AA"] = "aa";
    LanguageCode["AB"] = "ab";
    LanguageCode["AF"] = "af";
    LanguageCode["AK"] = "ak";
    LanguageCode["AM"] = "am";
    LanguageCode["AR"] = "ar";
    LanguageCode["AS"] = "as";
    LanguageCode["AW"] = "aw";
    LanguageCode["AY"] = "ay";
    LanguageCode["AZ"] = "az";
    LanguageCode["B1"] = "b1";
    LanguageCode["B2"] = "b2";
    LanguageCode["BA"] = "ba";
    LanguageCode["BE"] = "be";
    LanguageCode["BG"] = "bg";
    LanguageCode["BH"] = "bh";
    LanguageCode["BI"] = "bi";
    LanguageCode["BL"] = "bl";
    LanguageCode["BN"] = "bn";
    LanguageCode["BO"] = "bo";
    LanguageCode["BR"] = "br";
    LanguageCode["CA"] = "ca";
    LanguageCode["CB"] = "cb";
    LanguageCode["CE"] = "ce";
    LanguageCode["CO"] = "co";
    LanguageCode["CS"] = "cs";
    LanguageCode["CY"] = "cy";
    LanguageCode["DA"] = "da";
    LanguageCode["DE"] = "de";
    LanguageCode["DK"] = "dk";
    LanguageCode["DZ"] = "dz";
    LanguageCode["EL"] = "el";
    LanguageCode["EN"] = "en";
    LanguageCode["EO"] = "eo";
    LanguageCode["ES"] = "es";
    LanguageCode["ET"] = "et";
    LanguageCode["EU"] = "eu";
    LanguageCode["FA"] = "fa";
    LanguageCode["FI"] = "fi";
    LanguageCode["FJ"] = "fj";
    LanguageCode["FO"] = "fo";
    LanguageCode["FR"] = "fr";
    LanguageCode["FY"] = "fy";
    LanguageCode["GA"] = "ga";
    LanguageCode["GD"] = "gd";
    LanguageCode["GL"] = "gl";
    LanguageCode["GN"] = "gn";
    LanguageCode["GU"] = "gu";
    LanguageCode["HA"] = "ha";
    LanguageCode["HI"] = "hi";
    LanguageCode["HR"] = "hr";
    LanguageCode["HT"] = "ht";
    LanguageCode["HU"] = "hu";
    LanguageCode["HY"] = "hy";
    LanguageCode["IA"] = "ia";
    LanguageCode["IE"] = "ie";
    LanguageCode["IK"] = "ik";
    LanguageCode["IN"] = "in";
    LanguageCode["IS"] = "is";
    LanguageCode["IT"] = "it";
    LanguageCode["IW"] = "iw";
    LanguageCode["JA"] = "ja";
    LanguageCode["JI"] = "ji";
    LanguageCode["JW"] = "jw";
    LanguageCode["KA"] = "ka";
    LanguageCode["KB"] = "kb";
    LanguageCode["KI"] = "ki";
    LanguageCode["KK"] = "kk";
    LanguageCode["KL"] = "kl";
    LanguageCode["KM"] = "km";
    LanguageCode["KN"] = "kn";
    LanguageCode["KO"] = "ko";
    LanguageCode["KS"] = "ks";
    LanguageCode["KU"] = "ku";
    LanguageCode["KY"] = "ky";
    LanguageCode["LA"] = "la";
    LanguageCode["LB"] = "lb";
    LanguageCode["LM"] = "lm";
    LanguageCode["LN"] = "ln";
    LanguageCode["LO"] = "lo";
    LanguageCode["LT"] = "lt";
    LanguageCode["LV"] = "lv";
    LanguageCode["MG"] = "mg";
    LanguageCode["MI"] = "mi";
    LanguageCode["MK"] = "mk";
    LanguageCode["ML"] = "ml";
    LanguageCode["MN"] = "mn";
    LanguageCode["MO"] = "mo";
    LanguageCode["MR"] = "mr";
    LanguageCode["MS"] = "ms";
    LanguageCode["MT"] = "mt";
    LanguageCode["MU"] = "mu";
    LanguageCode["MW"] = "mw";
    LanguageCode["MY"] = "my";
    LanguageCode["NA"] = "na";
    LanguageCode["NE"] = "ne";
    LanguageCode["NL"] = "nl";
    LanguageCode["NO"] = "no";
    LanguageCode["OC"] = "oc";
    LanguageCode["OM"] = "om";
    LanguageCode["OR"] = "or";
    LanguageCode["PA"] = "pa";
    LanguageCode["PL"] = "pl";
    LanguageCode["PS"] = "ps";
    LanguageCode["PT"] = "pt";
    LanguageCode["QU"] = "qu";
    LanguageCode["RI"] = "ri";
    LanguageCode["RM"] = "rm";
    LanguageCode["RN"] = "rn";
    LanguageCode["RO"] = "ro";
    LanguageCode["RU"] = "ru";
    LanguageCode["RW"] = "rw";
    LanguageCode["SA"] = "sa";
    LanguageCode["SD"] = "sd";
    LanguageCode["SG"] = "sg";
    LanguageCode["SH"] = "sh";
    LanguageCode["SI"] = "si";
    LanguageCode["SK"] = "sk";
    LanguageCode["SL"] = "sl";
    LanguageCode["SM"] = "sm";
    LanguageCode["SN"] = "sn";
    LanguageCode["SO"] = "so";
    LanguageCode["SQ"] = "sq";
    LanguageCode["SR"] = "sr";
    LanguageCode["SS"] = "ss";
    LanguageCode["ST"] = "st";
    LanguageCode["SU"] = "su";
    LanguageCode["SV"] = "sv";
    LanguageCode["SW"] = "sw";
    LanguageCode["TA"] = "ta";
    LanguageCode["TE"] = "te";
    LanguageCode["TG"] = "tg";
    LanguageCode["TH"] = "th";
    LanguageCode["TI"] = "ti";
    LanguageCode["TK"] = "tk";
    LanguageCode["TL"] = "tl";
    LanguageCode["TM"] = "tm";
    LanguageCode["TN"] = "tn";
    LanguageCode["TO"] = "to";
    LanguageCode["TR"] = "tr";
    LanguageCode["TS"] = "ts";
    LanguageCode["TT"] = "tt";
    LanguageCode["TW"] = "tw";
    LanguageCode["TZ"] = "tz";
    LanguageCode["UG"] = "ug";
    LanguageCode["UK"] = "uk";
    LanguageCode["UR"] = "ur";
    LanguageCode["UZ"] = "uz";
    LanguageCode["VI"] = "vi";
    LanguageCode["VO"] = "vo";
    LanguageCode["WO"] = "wo";
    LanguageCode["XH"] = "xh";
    LanguageCode["YO"] = "yo";
    LanguageCode["ZH"] = "zh";
    LanguageCode["ZU"] = "zu"; // Zulu
})(LanguageCode || (exports.LanguageCode = LanguageCode = {}));
/**
 * Source: https://www.vendure.io/docs/typescript-api/common/currency-code/
 */
var CurrencyCode;
(function (CurrencyCode) {
    CurrencyCode["AED"] = "AED";
    CurrencyCode["AFN"] = "AFN";
    CurrencyCode["ALL"] = "ALL";
    CurrencyCode["AMD"] = "AMD";
    CurrencyCode["ANG"] = "ANG";
    CurrencyCode["AOA"] = "AOA";
    CurrencyCode["ARS"] = "ARS";
    CurrencyCode["AUD"] = "AUD";
    CurrencyCode["AWG"] = "AWG";
    CurrencyCode["AZN"] = "AZN";
    CurrencyCode["BAM"] = "BAM";
    CurrencyCode["BBD"] = "BBD";
    CurrencyCode["BDT"] = "BDT";
    CurrencyCode["BGN"] = "BGN";
    CurrencyCode["BHD"] = "BHD";
    CurrencyCode["BIF"] = "BIF";
    CurrencyCode["BMD"] = "BMD";
    CurrencyCode["BND"] = "BND";
    CurrencyCode["BOB"] = "BOB";
    CurrencyCode["BRL"] = "BRL";
    CurrencyCode["BSD"] = "BSD";
    CurrencyCode["BTN"] = "BTN";
    CurrencyCode["BWP"] = "BWP";
    CurrencyCode["BYN"] = "BYN";
    CurrencyCode["BZD"] = "BZD";
    CurrencyCode["CAD"] = "CAD";
    CurrencyCode["CDF"] = "CDF";
    CurrencyCode["CHF"] = "CHF";
    CurrencyCode["CLP"] = "CLP";
    CurrencyCode["CNY"] = "CNY";
    CurrencyCode["COP"] = "COP";
    CurrencyCode["CRC"] = "CRC";
    CurrencyCode["CUC"] = "CUC";
    CurrencyCode["CUP"] = "CUP";
    CurrencyCode["CVE"] = "CVE";
    CurrencyCode["CZK"] = "CZK";
    CurrencyCode["DJF"] = "DJF";
    CurrencyCode["DKK"] = "DKK";
    CurrencyCode["DOP"] = "DOP";
    CurrencyCode["DZD"] = "DZD";
    CurrencyCode["EGP"] = "EGP";
    CurrencyCode["ERN"] = "ERN";
    CurrencyCode["ETB"] = "ETB";
    CurrencyCode["EUR"] = "EUR";
    CurrencyCode["FJD"] = "FJD";
    CurrencyCode["FKP"] = "FKP";
    CurrencyCode["GBP"] = "GBP";
    CurrencyCode["GEL"] = "GEL";
    CurrencyCode["GHS"] = "GHS";
    CurrencyCode["GIP"] = "GIP";
    CurrencyCode["GMD"] = "GMD";
    CurrencyCode["GNF"] = "GNF";
    CurrencyCode["GTQ"] = "GTQ";
    CurrencyCode["GYD"] = "GYD";
    CurrencyCode["HKD"] = "HKD";
    CurrencyCode["HNL"] = "HNL";
    CurrencyCode["HRK"] = "HRK";
    CurrencyCode["HTG"] = "HTG";
    CurrencyCode["HUF"] = "HUF";
    CurrencyCode["IDR"] = "IDR";
    CurrencyCode["ILS"] = "ILS";
    CurrencyCode["INR"] = "INR";
    CurrencyCode["IQD"] = "IQD";
    CurrencyCode["IRR"] = "IRR";
    CurrencyCode["ISK"] = "ISK";
    CurrencyCode["JMD"] = "JMD";
    CurrencyCode["JOD"] = "JOD";
    CurrencyCode["JPY"] = "JPY";
    CurrencyCode["KES"] = "KES";
    CurrencyCode["KGS"] = "KGS";
    CurrencyCode["KHR"] = "KHR";
    CurrencyCode["KMF"] = "KMF";
    CurrencyCode["KPW"] = "KPW";
    CurrencyCode["KRW"] = "KRW";
    CurrencyCode["KWD"] = "KWD";
    CurrencyCode["KYD"] = "KYD";
    CurrencyCode["KZT"] = "KZT";
    CurrencyCode["LAK"] = "LAK";
    CurrencyCode["LBP"] = "LBP";
    CurrencyCode["LKR"] = "LKR";
    CurrencyCode["LRD"] = "LRD";
    CurrencyCode["LSL"] = "LSL";
    CurrencyCode["LYD"] = "LYD";
    CurrencyCode["MAD"] = "MAD";
    CurrencyCode["MDL"] = "MDL";
    CurrencyCode["MGA"] = "MGA";
    CurrencyCode["MKD"] = "MKD";
    CurrencyCode["MMK"] = "MMK";
    CurrencyCode["MNT"] = "MNT";
    CurrencyCode["MOP"] = "MOP";
    CurrencyCode["MRU"] = "MRU";
    CurrencyCode["MUR"] = "MUR";
    CurrencyCode["MVR"] = "MVR";
    CurrencyCode["MWK"] = "MWK";
    CurrencyCode["MXN"] = "MXN";
    CurrencyCode["MYR"] = "MYR";
    CurrencyCode["MZN"] = "MZN";
    CurrencyCode["NAD"] = "NAD";
    CurrencyCode["NGN"] = "NGN";
    CurrencyCode["NIO"] = "NIO";
    CurrencyCode["NOK"] = "NOK";
    CurrencyCode["NPR"] = "NPR";
    CurrencyCode["NZD"] = "NZD";
    CurrencyCode["OMR"] = "OMR";
    CurrencyCode["PAB"] = "PAB";
    CurrencyCode["PEN"] = "PEN";
    CurrencyCode["PGK"] = "PGK";
    CurrencyCode["PHP"] = "PHP";
    CurrencyCode["PKR"] = "PKR";
    CurrencyCode["PLN"] = "PLN";
    CurrencyCode["PYG"] = "PYG";
    CurrencyCode["QAR"] = "QAR";
    CurrencyCode["RON"] = "RON";
    CurrencyCode["RSD"] = "RSD";
    CurrencyCode["RUB"] = "RUB";
    CurrencyCode["RWF"] = "RWF";
    CurrencyCode["SAR"] = "SAR";
    CurrencyCode["SBD"] = "SBD";
    CurrencyCode["SCR"] = "SCR";
    CurrencyCode["SDG"] = "SDG";
    CurrencyCode["SEK"] = "SEK";
    CurrencyCode["SGD"] = "SGD";
    CurrencyCode["SHP"] = "SHP";
    CurrencyCode["SLL"] = "SLL";
    CurrencyCode["SOS"] = "SOS";
    CurrencyCode["SRD"] = "SRD";
    CurrencyCode["SSP"] = "SSP";
    CurrencyCode["STN"] = "STN";
    CurrencyCode["SVC"] = "SVC";
    CurrencyCode["SYP"] = "SYP";
    CurrencyCode["SZL"] = "SZL";
    CurrencyCode["THB"] = "THB";
    CurrencyCode["TJS"] = "TJS";
    CurrencyCode["TMT"] = "TMT";
    CurrencyCode["TND"] = "TND";
    CurrencyCode["TOP"] = "TOP";
    CurrencyCode["TRY"] = "TRY";
    CurrencyCode["TTD"] = "TTD";
    CurrencyCode["TWD"] = "TWD";
    CurrencyCode["TZS"] = "TZS";
    CurrencyCode["UAH"] = "UAH";
    CurrencyCode["UGX"] = "UGX";
    CurrencyCode["USD"] = "USD";
    CurrencyCode["UYU"] = "UYU";
    CurrencyCode["UZS"] = "UZS";
    CurrencyCode["VES"] = "VES";
    CurrencyCode["VND"] = "VND";
    CurrencyCode["VUV"] = "VUV";
    CurrencyCode["WST"] = "WST";
    CurrencyCode["XAF"] = "XAF";
    CurrencyCode["XCD"] = "XCD";
    CurrencyCode["XOF"] = "XOF";
    CurrencyCode["XPF"] = "XPF";
    CurrencyCode["YER"] = "YER";
    CurrencyCode["ZAR"] = "ZAR";
    CurrencyCode["ZMW"] = "ZMW";
    CurrencyCode["ZWL"] = "ZWL";
})(CurrencyCode || (exports.CurrencyCode = CurrencyCode = {}));
/**
 * This represents the locale identifier that can be used on DB columns
 * and in our platform to identify which locale should be used in our
 * SUPPORTED locales ONLY.
 */
var SupportedLocales;
(function (SupportedLocales) {
    SupportedLocales["cs"] = "cs";
    SupportedLocales["deDE"] = "de-DE";
    SupportedLocales["enAU"] = "en-AU";
    SupportedLocales["enCA"] = "en-CA";
    SupportedLocales["enGB"] = "en-GB";
    SupportedLocales["enUS"] = "en-US";
    SupportedLocales["esES"] = "es-ES";
    SupportedLocales["frBE"] = "fr-BE";
    SupportedLocales["frCA"] = "fr-CA";
    SupportedLocales["frFR"] = "fr-FR";
    SupportedLocales["itIT"] = "it-IT";
    SupportedLocales["nlNL"] = "nl-NL";
    SupportedLocales["nlBE"] = "nl-BE";
    SupportedLocales["pl"] = "pl";
    SupportedLocales["ptPT"] = "pt-PT";
})(SupportedLocales || (exports.SupportedLocales = SupportedLocales = {}));
/**
 * Shorter locales (ex. cs and pl) don't specify a region cause there is only
 * one region using that language. In our case we use the locale to extract the region
 * so we have this mapping to get a full locale including the region
 */
exports.shortLocaleToBestOption = (_a = {},
    _a[SupportedLocales.cs] = "".concat(SupportedLocales.cs, "-").concat(Countries_1.Countries.CzechRepublic),
    _a[SupportedLocales.pl] = "".concat(SupportedLocales.pl, "-").concat(Countries_1.Countries.Poland),
    _a);
/**
 * Those are so we are able to have localized currency, date format, etc.
 * but with english translations until we support more languages, text formats, etc.
 *
 * @example Thai will map to english but still identify the region as TH so we are able to
 *          get the currency and display properly on the Frontend
 */
var FrontendLocales;
(function (FrontendLocales) {
    FrontendLocales["esUS"] = "es-US";
    FrontendLocales["esMX"] = "es-MX";
    FrontendLocales["esCL"] = "es-CL";
    FrontendLocales["esCO"] = "es-CO";
    FrontendLocales["enTH"] = "en-TH";
    FrontendLocales["enVI"] = "en-VI";
    FrontendLocales["enPH"] = "en-PH";
    FrontendLocales["enAU"] = "en-AU"; // Australia - English
})(FrontendLocales || (exports.FrontendLocales = FrontendLocales = {}));
var SupportedLanguages;
(function (SupportedLanguages) {
    SupportedLanguages["CS"] = "cs";
    SupportedLanguages["DE"] = "de";
    SupportedLanguages["EN"] = "en";
    SupportedLanguages["ES"] = "es";
    SupportedLanguages["FR"] = "fr";
    SupportedLanguages["IT"] = "it";
    SupportedLanguages["NL"] = "nl";
    SupportedLanguages["PL"] = "pl";
    SupportedLanguages["PT"] = "pt";
})(SupportedLanguages || (exports.SupportedLanguages = SupportedLanguages = {}));
exports.localeToLanguage = (_b = {},
    _b[SupportedLocales.cs] = SupportedLanguages.CS,
    _b[SupportedLocales.deDE] = SupportedLanguages.DE,
    _b[SupportedLocales.enAU] = SupportedLanguages.EN,
    _b[SupportedLocales.enCA] = SupportedLanguages.EN,
    _b[SupportedLocales.enGB] = SupportedLanguages.EN,
    _b[SupportedLocales.enUS] = SupportedLanguages.EN,
    _b[SupportedLocales.esES] = SupportedLanguages.ES,
    _b[SupportedLocales.frBE] = SupportedLanguages.FR,
    _b[SupportedLocales.frCA] = SupportedLanguages.FR,
    _b[SupportedLocales.frFR] = SupportedLanguages.FR,
    _b[SupportedLocales.itIT] = SupportedLanguages.IT,
    _b[SupportedLocales.nlBE] = SupportedLanguages.NL,
    _b[SupportedLocales.nlNL] = SupportedLanguages.NL,
    _b[SupportedLocales.pl] = SupportedLanguages.PL,
    _b[SupportedLocales.ptPT] = SupportedLanguages.PT,
    _b[FrontendLocales.enPH] = SupportedLanguages.EN,
    _b[FrontendLocales.enTH] = SupportedLanguages.EN,
    _b[FrontendLocales.enVI] = SupportedLanguages.EN,
    _b[FrontendLocales.esUS] = SupportedLanguages.ES,
    _b[FrontendLocales.esMX] = SupportedLanguages.ES,
    _b[FrontendLocales.esCL] = SupportedLanguages.ES,
    _b[FrontendLocales.esCO] = SupportedLanguages.ES,
    _b);
var getSupportedLocaleFromAnyLocale = function (locale) {
    switch (locale) {
        case FrontendLocales.enAU:
        case FrontendLocales.enPH:
        case FrontendLocales.enTH:
        case FrontendLocales.enVI:
            return SupportedLocales.enUS;
        case FrontendLocales.esUS:
        case FrontendLocales.esMX:
        case FrontendLocales.esCL:
        case FrontendLocales.esCO:
            return SupportedLocales.esES;
        default: {
            if ((0, exports.isSupportedLocaleType)(locale)) {
                return locale;
            }
            else {
                return exports.DEFAULT_LOCALE;
            }
        }
    }
};
exports.getSupportedLocaleFromAnyLocale = getSupportedLocaleFromAnyLocale;
/**
 * Questions: we map all our translations in english to en but do we still
 * want to use en-GB, en-CA, etc on the BE ?
 */
exports.supportedLocales = Object.values(SupportedLocales);
var isSupportedLocaleType = function (locale) {
    return exports.supportedLocales.findIndex(function (l) { return l.toLowerCase() === (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()); }) >= 0;
};
exports.isSupportedLocaleType = isSupportedLocaleType;
// Key used to set the http context
exports.LOCALE_KEY = 'locale';
exports.DEFAULT_LOCALE = SupportedLocales.enUS;
/**
 * Extract a list of accepted locales/languages with the quality value from
 * 'Accept-Language' header.
 *
 * @param: acceptLanguage: 'Accept-Language' header value such as Accept-Language:zh-CN,zh;q=0.9,en;q=0.8,jp;q=0.7
 *
 * @example Accept-languages quality parameter can be understood like this:
 * by attaching Accept-Language: pl_PL;q=0.8, en_US;q=0.2, header to the request we communicate to the server following message
 * "Server, please provide me Polish translation of this website, but please do that only if its quality is >= %80% of related-quality-factor.
 *  In case quality is <80% - I do not mind getting the English version, because it is irrelevant for me since I speak English anyway.
 */
function extractLocalesFromAcceptLanguageHeader(acceptLanguage) {
    if (acceptLanguage) {
        var langs = acceptLanguage
            .split(',')
            .map(function (item) {
            var values = item.split(';');
            var locale = values[0];
            var _a = locale.split('-'), language = _a[0], region = _a[1];
            // Our standard should follow the use of UPPER_CASE regions (CA, US, GB, etc.)
            var languageKey = region
                ? "".concat(language, "-").concat(region.toUpperCase())
                : language;
            var quality = values[1] ? parseFloat(values[1].split('=')[1]) : 1;
            return { locale: languageKey, quality: quality };
        })
            .sort(function (a, b) { return b.quality - a.quality; });
        return langs;
    }
    return null;
}
/**
 * @example With en-TH that is made up only to fit our context where we want to support currency but not languages yet:
 * {
 *    baseName: "en-TH",
 *    calendar: undefined,
 *    calendars: ['buddhist', 'gregory'],
 *    caseFirst: undefined,
 *    collation: undefined,
 *    collations: (2) ['emoji', 'eor'],
 *    hourCycle: undefined,
 *    hourCycles: ['h23'],
 *    language: "en",
 *    numberingSystem: undefined,
 *    numberingSystems: ['latn'],
 *    numeric: false,
 *    region: "TH",
 *    script: undefined,
 *    textInfo: {direction: 'ltr'},
 *    timeZones: ['Asia/Bangkok'],
 *    weekInfo: {firstDay: 7, weekend: Array(2), minimalDays: 1}
 */
function extractLocaleInformation(locale) {
    return new Intl.Locale(locale.length === 2 ? exports.shortLocaleToBestOption[locale] || locale : locale);
}
/**
 * Uses intl to extract the 2 letter region code and make sure it's a proper country code
 * base on ISO standards. If no region is found with the locale sent it will use the fallback
 * option that defaults to USD
 *
 * @param locale: locale to extract the proper currency code from
 * @param options
 * @param options.fallbackCurrency: currency to fallback to if no proper currency is found from the locale string
 */
var getCurrencyFromLocale = function (locale, _a) {
    var _b = _a === void 0 ? { fallbackCurrency: CurrencyCode.USD } : _a, fallbackCurrency = _b.fallbackCurrency;
    var localeObj = extractLocaleInformation(locale);
    if (localeObj.region && exports.countryToCurrency[localeObj.region.toUpperCase()]) {
        return exports.countryToCurrency[localeObj.region.toUpperCase()];
    }
    return fallbackCurrency;
};
exports.getCurrencyFromLocale = getCurrencyFromLocale;
exports.countryToCurrency = {
    AD: CurrencyCode.EUR,
    AE: CurrencyCode.AED,
    AF: CurrencyCode.AFN,
    AG: CurrencyCode.XCD,
    AI: CurrencyCode.XCD,
    AL: CurrencyCode.ALL,
    AM: CurrencyCode.AMD,
    AN: CurrencyCode.ANG,
    AO: CurrencyCode.AOA,
    AR: CurrencyCode.ARS,
    AS: CurrencyCode.USD,
    AT: CurrencyCode.EUR,
    AU: CurrencyCode.AUD,
    AW: CurrencyCode.AWG,
    AX: CurrencyCode.EUR,
    AZ: CurrencyCode.AZN,
    BA: CurrencyCode.BAM,
    BB: CurrencyCode.BBD,
    BD: CurrencyCode.BDT,
    BE: CurrencyCode.EUR,
    BF: CurrencyCode.XOF,
    BG: CurrencyCode.BGN,
    BH: CurrencyCode.BHD,
    BI: CurrencyCode.BIF,
    BJ: CurrencyCode.XOF,
    BL: CurrencyCode.EUR,
    BM: CurrencyCode.BMD,
    BN: CurrencyCode.BND,
    BO: CurrencyCode.BOB,
    BR: CurrencyCode.BRL,
    BS: CurrencyCode.BSD,
    BT: CurrencyCode.BTN,
    BV: CurrencyCode.NOK,
    BW: CurrencyCode.BWP,
    BY: CurrencyCode.BYN,
    BZ: CurrencyCode.BZD,
    CA: CurrencyCode.CAD,
    CC: CurrencyCode.AUD,
    CD: CurrencyCode.CDF,
    CF: CurrencyCode.XAF,
    CG: CurrencyCode.CDF,
    CH: CurrencyCode.CHF,
    CI: CurrencyCode.XOF,
    CK: CurrencyCode.NZD,
    CL: CurrencyCode.CLP,
    CM: CurrencyCode.XAF,
    CN: CurrencyCode.CNY,
    CO: CurrencyCode.COP,
    CR: CurrencyCode.CRC,
    CU: CurrencyCode.CUC,
    CV: CurrencyCode.CVE,
    CX: CurrencyCode.AUD,
    CY: CurrencyCode.EUR,
    CZ: CurrencyCode.CZK,
    DE: CurrencyCode.EUR,
    DJ: CurrencyCode.DJF,
    DK: CurrencyCode.DKK,
    DM: CurrencyCode.DOP,
    DO: CurrencyCode.DOP,
    DZ: CurrencyCode.DZD,
    EC: CurrencyCode.USD,
    EE: CurrencyCode.EUR,
    EG: CurrencyCode.EGP,
    EH: CurrencyCode.MAD,
    ER: CurrencyCode.ERN,
    ES: CurrencyCode.EUR,
    ET: CurrencyCode.ETB,
    FI: CurrencyCode.EUR,
    FJ: CurrencyCode.FJD,
    FM: CurrencyCode.USD,
    FO: CurrencyCode.DKK,
    FR: CurrencyCode.EUR,
    GA: CurrencyCode.XAF,
    GB: CurrencyCode.GBP,
    GD: CurrencyCode.XCD,
    GE: CurrencyCode.GEL,
    GF: CurrencyCode.EUR,
    GG: CurrencyCode.GBP,
    GH: CurrencyCode.GHS,
    GI: CurrencyCode.GIP,
    GL: CurrencyCode.DKK,
    GM: CurrencyCode.GMD,
    GN: CurrencyCode.GNF,
    GP: CurrencyCode.EUR,
    GQ: CurrencyCode.XAF,
    GR: CurrencyCode.EUR,
    GT: CurrencyCode.GTQ,
    GU: CurrencyCode.USD,
    GW: CurrencyCode.XOF,
    GY: CurrencyCode.GYD,
    HK: CurrencyCode.HKD,
    HN: CurrencyCode.HNL,
    HR: CurrencyCode.EUR,
    HT: CurrencyCode.HTG,
    HU: CurrencyCode.HUF,
    ID: CurrencyCode.IDR,
    IE: CurrencyCode.EUR,
    IL: CurrencyCode.ILS,
    IM: CurrencyCode.GBP,
    IN: CurrencyCode.INR,
    IO: CurrencyCode.USD,
    IQ: CurrencyCode.IQD,
    IR: CurrencyCode.IRR,
    IS: CurrencyCode.ISK,
    IT: CurrencyCode.EUR,
    JE: CurrencyCode.GBP,
    JM: CurrencyCode.JMD,
    JO: CurrencyCode.JOD,
    JP: CurrencyCode.JPY,
    KE: CurrencyCode.KES,
    KG: CurrencyCode.KGS,
    KH: CurrencyCode.KHR,
    KI: CurrencyCode.AUD,
    KM: CurrencyCode.KMF,
    KN: CurrencyCode.XCD,
    KR: CurrencyCode.KRW,
    KW: CurrencyCode.KWD,
    KY: CurrencyCode.KYD,
    KZ: CurrencyCode.KZT,
    LB: CurrencyCode.LBP,
    LC: CurrencyCode.XCD,
    LI: CurrencyCode.CHF,
    LK: CurrencyCode.LKR,
    LR: CurrencyCode.LRD,
    LS: CurrencyCode.LSL,
    LT: CurrencyCode.EUR,
    LU: CurrencyCode.EUR,
    LV: CurrencyCode.EUR,
    LY: CurrencyCode.LYD,
    MA: CurrencyCode.MAD,
    MC: CurrencyCode.EUR,
    MD: CurrencyCode.MDL,
    ME: CurrencyCode.EUR,
    MF: CurrencyCode.EUR,
    MG: CurrencyCode.MGA,
    MH: CurrencyCode.USD,
    ML: CurrencyCode.XOF,
    MM: CurrencyCode.MMK,
    MN: CurrencyCode.MNT,
    MO: CurrencyCode.MOP,
    MP: CurrencyCode.USD,
    MQ: CurrencyCode.EUR,
    MR: CurrencyCode.MRU,
    MS: CurrencyCode.XCD,
    MT: CurrencyCode.EUR,
    MU: CurrencyCode.MUR,
    MV: CurrencyCode.MVR,
    MW: CurrencyCode.MWK,
    MX: CurrencyCode.MXN,
    MY: CurrencyCode.MYR,
    MZ: CurrencyCode.MZN,
    NA: CurrencyCode.NAD,
    NC: CurrencyCode.XPF,
    NE: CurrencyCode.NGN,
    NF: CurrencyCode.AUD,
    NG: CurrencyCode.NGN,
    NI: CurrencyCode.NIO,
    NL: CurrencyCode.EUR,
    NO: CurrencyCode.NOK,
    NP: CurrencyCode.NPR,
    NR: CurrencyCode.AUD,
    NU: CurrencyCode.NZD,
    NZ: CurrencyCode.NZD,
    OM: CurrencyCode.OMR,
    PA: CurrencyCode.PAB,
    PE: CurrencyCode.PEN,
    PF: CurrencyCode.XPF,
    PG: CurrencyCode.PGK,
    PH: CurrencyCode.PHP,
    PK: CurrencyCode.PKR,
    PL: CurrencyCode.PLN,
    PM: CurrencyCode.EUR,
    PN: CurrencyCode.NZD,
    PR: CurrencyCode.USD,
    PT: CurrencyCode.EUR,
    PW: CurrencyCode.USD,
    PY: CurrencyCode.PYG,
    QA: CurrencyCode.QAR,
    RE: CurrencyCode.EUR,
    RO: CurrencyCode.RON,
    RS: CurrencyCode.RSD,
    RU: CurrencyCode.RUB,
    RW: CurrencyCode.RWF,
    SA: CurrencyCode.SAR,
    SB: CurrencyCode.SBD,
    SC: CurrencyCode.SCR,
    SD: CurrencyCode.SDG,
    SE: CurrencyCode.SEK,
    SG: CurrencyCode.SGD,
    SH: CurrencyCode.SHP,
    SI: CurrencyCode.EUR,
    SJ: CurrencyCode.NOK,
    SK: CurrencyCode.EUR,
    SL: CurrencyCode.SLL,
    SM: CurrencyCode.EUR,
    SN: CurrencyCode.XOF,
    SO: CurrencyCode.SOS,
    SR: CurrencyCode.SRD,
    ST: CurrencyCode.STN,
    SV: CurrencyCode.SVC,
    SY: CurrencyCode.SYP,
    SZ: CurrencyCode.SZL,
    TC: CurrencyCode.USD,
    TD: CurrencyCode.XAF,
    TF: CurrencyCode.EUR,
    TG: CurrencyCode.XOF,
    TH: CurrencyCode.THB,
    TJ: CurrencyCode.TJS,
    TK: CurrencyCode.NZD,
    TL: CurrencyCode.USD,
    TM: CurrencyCode.TMT,
    TN: CurrencyCode.TND,
    TO: CurrencyCode.TOP,
    TR: CurrencyCode.TRY,
    TT: CurrencyCode.TTD,
    TV: CurrencyCode.AUD,
    TW: CurrencyCode.TWD,
    TZ: CurrencyCode.TZS,
    UA: CurrencyCode.UAH,
    UG: CurrencyCode.UGX,
    UM: CurrencyCode.USD,
    US: CurrencyCode.USD,
    UY: CurrencyCode.UYU,
    UZ: CurrencyCode.UZS,
    VA: CurrencyCode.EUR,
    VC: CurrencyCode.XCD,
    VE: CurrencyCode.VES,
    VG: CurrencyCode.USD,
    VI: CurrencyCode.USD,
    VN: CurrencyCode.VND,
    VU: CurrencyCode.VUV,
    WF: CurrencyCode.XPF,
    WS: CurrencyCode.USD,
    YE: CurrencyCode.YER,
    YT: CurrencyCode.EUR,
    ZA: CurrencyCode.ZAR,
    ZM: CurrencyCode.ZMW,
    ZW: CurrencyCode.ZWL,
    HM: CurrencyCode.AUD,
    FK: CurrencyCode.FKP,
    GS: CurrencyCode.GEL,
    LA: CurrencyCode.LAK,
    MK: CurrencyCode.MKD,
    AQ: CurrencyCode.USD,
    PS: CurrencyCode.ILS
};
//# sourceMappingURL=Locale.js.map